import React from 'react';
import { SearchIcon } from '../../../images';
import styles from './search.module.scss';
import classnames from 'classnames';
import { Lang } from 'shared/constants';

const SearchComponent = React.memo(function SearchComponent({
  searchTerm = null,
  updateSearch = () => {},
  lang = Lang.WIDGET,
  light = true,
  placeholder = Lang.WIDGET.SEARCH_PLACEHOLDER,
}) {
  const onSearch = React.useCallback(
    ({ target }) => {
      updateSearch(target.value);
    },
    [updateSearch],
  );

  return (
    <div className={classnames([styles.root, searchTerm && light && styles.lightBackground])}>
      <input className={styles.input} onChange={onSearch} placeholder={placeholder} />
      <SearchIcon className={classnames([styles.icon, searchTerm && styles.darkIcon])} />
    </div>
  );
});

export { SearchComponent };
